import React, { useState } from 'react';
import "./Nav.scss";
import SupportModal from './SupportModal';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { getSessionStorageItem, ADVISOR_OBJECT_KEY } from '../../sessionStorage';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  imgColor: {
      color: theme.palette.primary.main
  }
}));

export default function Nav(props) {

  const { logoURL, expanded } = props;
  const classes = useStyles();
  const userData = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  const [ricProfileImageError, setRicProfileImageError] = useState(!userData.ricProfileImageURL);
  const [supportDialog, setSupportDialog] = useState(null);
  const [isSupportDialogOpen, setIsSupportDialogOpen] = useState(false);

  const onDialogClosed = () => {
    setIsSupportDialogOpen(false);
  }
  const handleClick = () => {
      setSupportDialog(<SupportModal isAIP={true} userData={userData} getAltText={(name) => getAltText(name)} />)
    setIsSupportDialogOpen(true);
  }

  const getAltText = (name) => {
    if (!name) {
      return '';
    }

    const splitedName = name.split(' ');
    const firstnameInitial = splitedName[0].charAt(0);
    const lastNameInitial = splitedName[1].charAt(0);
    return firstnameInitial + lastNameInitial;
  }

  return (
    <div id="advisor-nav" className={`sticky-top  ${expanded ? "sidebar-open" : "sidebar-close"}`}>
      <div>
        <img id="partner-logo" alt="partner-logo" src={logoURL} />

        <div id="advisor-agent-nav" onClick={() => handleClick()} >
          {
            ricProfileImageError ?
              <div className={`image-style ric-image-name-style mr-3 ${classes.imgColor}`}>{getAltText(userData.iscName)}</div>
              :
              <img className={`image-style mr-3`} src={userData.ricProfileImageURL} onError={() => setRicProfileImageError(true)} alt="logo"/>
          }
          <div id="isc-profile" >
            <div className='pt-1'>
              <span id="isc-name">Regional <br/>Insurance Consultant</span><br />
            </div>
          </div>
        </div>
      </div>

      <Dialog className="stylecss" open={isSupportDialogOpen} onClose={onDialogClosed} maxWidth={'xl'} fullWidth={true} scroll="body">
        <DialogContent className="apply-dialog-button p-0">
          <IconButton className="apply-dialog-close-button z-index-button" aria-label="close" onClick={onDialogClosed}>
            <CloseIcon />
          </IconButton>
          {supportDialog}
        </DialogContent>
      </Dialog>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Layout/Nav.js